import { useCallback, useState } from 'react';

import Button from 'components/shared/Button';
import FilterBarComponent from 'components/shared/filters/FilterBar';
import { useProfile } from 'context/profile';
import { PERMISSIONS } from 'models/Profile';
import { useHealthPlansActions } from 'stores/healthPlansStore';
import PlusIcon from 'svg/PlusIcon';

import AddAcceptedPlanModal from '../modals/acceptedPlans/AddAcceptedPlanModal';

const FilterBar = () => {
  const [showAddPlanModal, setShowAddPlanModal] = useState(false);
  const { setSearch } = useHealthPlansActions();

  const { profile } = useProfile();

  const handleApplyFilters = useCallback(
    ({ search }) => {
      setSearch(search);
    },
    [setSearch]
  );

  return (
    <>
      <FilterBarComponent
        showSearchInput={true}
        searchPlaceholder='Search Health Plan'
        applyFilters={handleApplyFilters}
        filters={{}}
        showResults={false}
        filterSections={[]}
        onClearFilters={() => {}}
        showFiltersButton={false}
        title='Contracted Health Plans'
        callToAction={
          profile.has(PERMISSIONS.clientClassificationsEdit) && (
            <Button variant='primary' size='small' onClick={() => setShowAddPlanModal(true)}>
              <PlusIcon width={12} height={12} />
              Add Contracted Health Plan
            </Button>
          )
        }
      />
      {showAddPlanModal && profile.has(PERMISSIONS.clientClassificationsEdit) && (
        <AddAcceptedPlanModal setShow={setShowAddPlanModal} clientId={profile.actingClient.id} />
      )}
    </>
  );
};

export default FilterBar;
